import { matchPath } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as types from 'modules/vehicleCheckModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = false;

const onLocationMatchMatcher = {
  matcher: ({ type, payload }) =>
    type === LOCATION_CHANGE &&
    (matchPath(PATH.VEHICLE_CHECK_MODEL_DETAILED.path, payload.location.pathname) !== null ||
      matchPath(PATH.GROUP_VEHICLE_CHECK_MODEL_DETAILED.path, payload.location.pathname) !== null),
  reducer: () => false,
};

export default createReducer(
  initialState,
  {
    [types.DETAILS_PAGE_IS_READY]: () => true,
  },
  [onLocationMatchMatcher]
);
